module.exports = __webpack_public_path__ + "img/ls.bcd2c7b2.png";